import { defineAsyncComponent } from 'vue';

const SettingLayout = defineAsyncComponent(() =>
  import(/* webpackChunkName:'settinglayout'*/ '@/views/common/SettingLayout.vue'),
);

const SettingLayoutSalary = defineAsyncComponent(() =>
  import(/* webpackChunkName:'settingLayoutSalary'*/ '@/views/common/SettingLayoutSalary.vue'),
);

const ImportExcel = defineAsyncComponent(() =>
  import(/* webpackChunkName:'settinglayout'*/ '@/views/common/import/ImportExcel.vue'),
);
const ImportInfo = defineAsyncComponent(() =>
  import(/* webpackChunkName:'settinglayout'*/ '@/views/common/import/ImportInfoPopup.vue'),
);

const UploadForm = defineAsyncComponent(() =>
  import(/* webpackChunkName:'settinglayout'*/ '@/views/common/upload/UploadForm.vue'),
);

const UploadFormCustomFileType = defineAsyncComponent(() =>
  import(/* webpackChunkName:'settinglayout'*/ '@/views/common/upload/UploadFormCustomFileType.vue'),
);

const ChooseOption = defineAsyncComponent(() =>
  import(/* webpackChunkName:'settinglayout'*/ '@/views/common/chooseOption/ChooseOption.vue'),
);

const ImportBeforeData = defineAsyncComponent(() =>
  import(/* webpackChunkName:'settinglayout'*/ '@/views/beforeData/import/ImportBeforeData.vue'),
);

const SettingDisplayPopup = defineAsyncComponent(() =>
  import(/* webpackChunkName:'settinglayout'*/ '@/views/utility/settingDisplay/SettingDisplayPopup.vue'),
);


const ConfirmRedirectPopup = defineAsyncComponent(() =>
  import(/* webpackChunkName:'settinglayout'*/ '@/pages/ConfirmRedirectPopup.vue'),
);
//Bắt đầu sử dụng
const StartUsingPopup = defineAsyncComponent(() =>
  import(/* webpackChunkName:'settinglayout'*/ '@/pages/StartUsingPopup.vue'),
);

//Bắt đầu sử dụng IHOS
const GettingStartedPopup = defineAsyncComponent(() =>
  import(/* webpackChunkName:'settinglayout'*/ '@/pages/GettingStartedPopup.vue'),
);

const StartUsingIHOSPopup = defineAsyncComponent(() =>
  import(/* webpackChunkName:'settinglayout'*/ '@/pages/StartUsingIHOSPopup.vue'),
);
const StartUpgradeIHOSPopup = defineAsyncComponent(() =>
  import(/* webpackChunkName:'settinglayout'*/ '@/pages/StartUpgradeIHOSPopup.vue'),
);


const ImportSalaryExcel = defineAsyncComponent(() =>
  import(/* webpackChunkName:'settinglayout'*/ '@/views/common/importSalary/ImportSalaryExcel.vue'),
);
const OrganizationGroupPopup = defineAsyncComponent(() =>
  import(/* webpackChunkName:'settinglayout'*/ '@/views/system/OrganizationGroup/OrganizationGroupPopup.vue'),
);
const OrganizationGroupDetailPopup = defineAsyncComponent(() =>
  import(/* webpackChunkName:'settinglayout'*/ '@/views/system/OrganizationGroup/OrganizationGroupDetailPopup.vue'),
);

const OrganizationGroupAffiliatePopup = defineAsyncComponent(() =>
  import(/* webpackChunkName:'settinglayout'*/ '@/views/system/OrganizationGroup/OrganizationGroupAffiliatePopup.vue'),
);

const ExpenseInvestMappingSource = defineAsyncComponent(() =>
  import(/* webpackChunkName:'settinglayout'*/ '@/views/system/ExpenseInvestMappingSource.vue'),
);

const SortOrganizationChildPopup = defineAsyncComponent(() =>
  import(/* webpackChunkName:'settinglayout'*/ '@/views/utility/sortOrganization/SortOrganizationChildPopup.vue'),
);

const LayoutSettingPopup = defineAsyncComponent(() =>
  import(/* webpackChunkName:'settinglayout'*/ '@/views/utility/layoutSetting/LayoutSettingPopup.vue'),
);
const ExpireDatePopUp = defineAsyncComponent(() =>
  import(/* webpackChunkName:'settinglayout'*/ '@/pages/license/ExpireDatePopUp.vue'),
);
const LicenseInfoPopup = defineAsyncComponent(() =>
  import(/* webpackChunkName:'settinglayout'*/ '@/pages/license/LicenseInfoPopup.vue'),
);

export function registerCommonPopup(app) {
  app.component('SettingLayout', SettingLayout);
  app.component('SettingLayoutSalary', SettingLayoutSalary);
  app.component('ImportExcel', ImportExcel);
  app.component('ImportInfo', ImportInfo);
  app.component('UploadForm', UploadForm);
  app.component('UploadFormCustomFileType', UploadFormCustomFileType);
  app.component('ImportBeforeData', ImportBeforeData);
  app.component('ChooseOption', ChooseOption);
  app.component('SettingDisplayPopup', SettingDisplayPopup);
  app.component('ConfirmRedirectPopup', ConfirmRedirectPopup);
  app.component('StartUsingPopup', StartUsingPopup);
  app.component('ImportSalaryExcel', ImportSalaryExcel);
  app.component('OrganizationGroupPopup', OrganizationGroupPopup)
  app.component('OrganizationGroupDetailPopup', OrganizationGroupDetailPopup)
  app.component('OrganizationGroupAffiliatePopup', OrganizationGroupAffiliatePopup)
  app.component('ExpenseInvestMappingSource', ExpenseInvestMappingSource)
  app.component('SortOrganizationChildPopup', SortOrganizationChildPopup)
  app.component('LayoutSettingPopup', LayoutSettingPopup),
  app.component('ExpireDatePopUp', ExpireDatePopUp),
  app.component('LicenseInfoPopup', LicenseInfoPopup),
  app.component('GettingStartedPopup', GettingStartedPopup);
  app.component('StartUsingIHOSPopup', StartUsingIHOSPopup);
  app.component('StartUpgradeIHOSPopup', StartUpgradeIHOSPopup);
}
